module.exports = Object.freeze({
    PUBLIC_PATH: '/',
    HOSTNAME: 'https://cybo.de',
    API: 'https://api.cybo.de',
})
